import { MODAL } from '@socialive/common';
import { ModalProxy } from '@socialive/modals';
import PropTypes from 'prop-types';
import CreateBroadcastModal from '../CreateBroadcastModal';
import CreateRecordingModal from '../CreateRecordingModal';
import RecordingUploadModal from '../RecordingUploadModal';
import RolesLicensingModal from '../RolesLicensingModal';

const ModalProxies = ({ reAuth, trackEvent, loadBroadcasts }) => (
  <>
    <ModalProxy modalId={MODAL.CREATE_RECORDING} render={CreateRecordingModal} />
    <ModalProxy modalId={MODAL.MEDIA_UPLOAD} render={RecordingUploadModal} />
    <ModalProxy modalId={MODAL.ROLES_LICENSING} render={RolesLicensingModal} />
    <ModalProxy
      modalId={MODAL.CREATE_BROADCAST}
      render={CreateBroadcastModal}
      reAuth={reAuth}
      trackEvent={trackEvent}
      loadBroadcasts={loadBroadcasts}
    />
  </>
);

ModalProxies.propTypes = {
  loadBroadcasts: PropTypes.func.isRequired,
  reAuth: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

export default ModalProxies;
